<template>
  <div v-if="data" class="pcn">
    <div v-for="(product, index) in data.products" :key="index" class="pcn__product">
      <ProductCard :product="product" :isLoadingLazy="true" />
    </div>
  </div>
</template>

<script setup="props">
  import ProductCard from './product-card.vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
  });
</script>
